module.exports = __webpack_public_path__ + "img/icon_package_primary.bdfacee6.png";